import React from 'react';
import { useTheme } from '../contexts/ThemeContext'; // Adjust path if needed
import { MdOutlineWbSunny, MdOutlineNightlight } from 'react-icons/md'; // Example icons

function ThemeToggleButton() {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="btn btn-outline-secondary ms-lg-2" // Added ms-lg-2 for spacing on larger screens
      aria-label={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
      style={{ display: 'flex', alignItems: 'center' }} // For better icon alignment
    >
      {theme === 'light' ? <MdOutlineNightlight size="1.3em" /> : <MdOutlineWbSunny size="1.3em" />}
      <span className="ms-2 d-none d-md-inline"> {/* Hide text on small screens */}
        {theme === 'light' ? 'Dark' : 'Light'}
      </span>
    </button>
  );
}

export default ThemeToggleButton;